"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printer = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var printer = function printer(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'printer-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M17.0803 8.11303C16.632 7.44196 15.8676 7 15 7H5C3.61929 7 2.5 8.11929 2.5 9.5V14.25H5V12C5 11.4477 5.44772 11 6 11H14C14.5523 11 15 11.4477 15 12V14.25H17.5V9.5C17.5 9.42274 17.4965 9.34627 17.4896 9.27077C17.4509 8.84539 17.3055 8.45036 17.0803 8.11303ZM6.5 17.5H13.5V12.5H6.5V17.5ZM16 5.62602C16.0638 5.64244 16.127 5.66039 16.1895 5.67983C17.8178 6.18628 19 7.70507 19 9.5V14.75C19 15.3023 18.5523 15.75 18 15.75H15V18C15 18.5523 14.5523 19 14 19H6C5.44772 19 5 18.5523 5 18V15.75H2C1.44772 15.75 1 15.3023 1 14.75V9.5C1 7.63616 2.27477 6.07006 4 5.62602V2C4 1.44772 4.44772 1 5 1H15C15.5523 1 16 1.44772 16 2V5.62602ZM5.5 2.5H14.5V5.5H5.5V2.5Z',
    fill: '#4B5563'
  }));
};

exports.printer = printer;